import React from 'react';
import DiscordInvite from '../components/DiscordInvite';
import { publishers } from '../data/publishers';
import PublisherCard from '../components/PublisherCard';

const ResourcesReferences = () => {
  return (
    <div style={{ padding: '1rem' }}>
        <h1>Resources & References</h1>
        <h2>Connect with the Gaming Community</h2>
        <p>Want to have engaging conversations with other gamers about the games you play?</p>
        
        <div style={{ 
            border: '2px solid #4a90e2', 
            borderRadius: '8px', 
            padding: '1.5rem', 
            marginTop: '1rem',
            backgroundColor: '#f8f9fa',
            textAlign: 'center'
        }}>
            <div style={{ marginBottom: '1rem' }}>
            <img 
                src="https://cf.geekdo-static.com/images/logos/navbar-logo-bgg-b2.svg" 
                alt="BoardGameGeek Logo" 
                style={{ 
                height: '60px', 
                maxWidth: '200px',
                objectFit: 'contain'
                }}
            />
            </div>
            <p style={{ 
            fontSize: '1.1rem', 
            marginBottom: '1rem',
            color: '#333'
            }}>
            Check out the amazing community at <strong>BoardGameGeek</strong> - the ultimate destination for board game enthusiasts!
            </p>
            <a 
            href="https://boardgamegeek.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
                display: 'inline-block',
                backgroundColor: '#4a90e2',
                color: 'white',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '1rem',
                transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#357abd'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#4a90e2'}
            >
            Visit BoardGameGeek →
            </a>
            <p style={{ 
            fontSize: '0.9rem', 
            marginTop: '1rem',
            color: '#666',
            fontStyle: 'italic'
            }}>
            Discover reviews, ratings, forums, and everything board game related!
            </p>
        </div>
        <h2>The Publishers</h2>
        <p>Explore the official websites of game publishers whose titles we support:</p>
        <div className="publishers-grid">
            {publishers
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((publisher, index) => (
                    <PublisherCard key={index} publisher={publisher} />
                ))
            }
        </div>
    </div>
  );
};

export default ResourcesReferences;
